import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash.isnil';
import { ERROR } from '../../../constants/shared/CommonConstants';
import { CLASS_NAME } from '../../../constants/shared/WebEntryConstants';

const { PREVENT_VALIDATION } = CLASS_NAME;

const InputCell = ({ isNotEditable, dataString, dataStringClassName, input }) => {
    const { isRowDisabled, error, handleChange, handleKeyDown, name, inputClassName, className } =
        input;
    const errorClassName =
        error && error.highlightedInputs.find(inputName => inputName === name) ? ERROR : '';

    if (isNotEditable) {
        return (
            <div className={`display-container ${dataStringClassName}`}>
                <div className="display-value">{isNil(dataString) ? '- -' : dataString}</div>
            </div>
        );
    }

    return (
        <div className={`input-container ${className}`}>
            <input
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                className={`date-global-style ${inputClassName} ${errorClassName} ${
                    isRowDisabled ? 'disabled' : ''
                } ${PREVENT_VALIDATION}`}
                type="number"
                min="0"
                placeholder="- -"
                disabled={isRowDisabled}
            />
        </div>
    );
};

InputCell.defaultProps = {
    isNotEditable: false,
    dataString: null,
    dataStringClassName: '',
    input: {},
};

InputCell.propTypes = {
    isNotEditable: PropTypes.bool,
    dataString: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dataStringClassName: PropTypes.string,
    input: PropTypes.object,
};
export default InputCell;
